export const PLOT_LOADING = "PLOT_LOADING";
export const PLOT_FAIL = "PLOT_FAIL";
export const PLOT_SUCCESS = "PLOT_SUCCESS";

export const PLOT_EDIT = "PLOT_EDIT";

export interface PlotLoading {

    type: typeof PLOT_LOADING

}

export interface PlotEdit {

    type: typeof PLOT_EDIT,
    payload: any

}


export interface PlotSuccess {

    type: typeof PLOT_SUCCESS,
    payload: any
    
}


export interface PlotFail {

    type: typeof PLOT_FAIL,
    payload: any
    
}


export type PlotDispatchTypes = PlotFail | PlotLoading | PlotSuccess | PlotEdit;